
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(80(27|38)|3114|4580|6337|7296|7636|9535)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
